/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type { FeatureFlagsResponse } from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getFeatureFlags = () => {
  /**
 * Get all feature flags for the authenticated user's organization.

Returns a dict mapping flag names to their enabled status.
Missing flags return their default value.
 * @summary Get Feature Flags
 */
  const featureFlagsGetFeatureFlags = (
    options?: SecondParameter<typeof axiosInstance<FeatureFlagsResponse>>
  ) => {
    return axiosInstance<FeatureFlagsResponse>(
      { url: `/feature_flags`, method: 'GET' },
      options
    );
  };
  return { featureFlagsGetFeatureFlags };
};
export type FeatureFlagsGetFeatureFlagsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getFeatureFlags>['featureFlagsGetFeatureFlags']
    >
  >
>;
